import Image from "next/image";
import Collapsible from "react-collapsible";
import styles from "../faq.module.scss";

export default function SelectiveProcess() {
  const handleOpen = (index: number) => {
    const arrow = document.querySelector(`.arrowSelectiveProcess${index}`);
    arrow?.classList.toggle(styles.active);
  };
  return (
    <div className={styles.questionWrapper} data-aos="fade-down">
      <h2 className={styles.title}>03. Matrícula</h2>

      <Collapsible
        trigger={
          <div className={styles.questionTitle} onClick={() => handleOpen(0)}>
            <h3>Como funciona a matrícula?</h3>
            <Image
              src="/images/arrow-down.svg"
              alt="Ícone de pergunta"
              width="23"
              height="14"
              className={`arrowSelectiveProcess0`}
            />
          </div>
        }
        className={styles.dropdown}
      >
        <article className={styles.question}>
          <div>
            <p>Acesso de matrícula não tem burocracia:</p>
            <ul>
              <li>
                <strong>Inscrição</strong>: a partir do nosso site, você
                preenche um formulário com os seus principais dados.
              </li>
              <li>
                <strong>Contato</strong>: o nosso time de Admissões fará contato
                pelo WhatsApp ou e-mail para validar algumas informações e te
                conhecer melhor!
              </li>
              <li>
                <strong>Assinatura de contrato</strong>: depois de passar pelas
                etapas acima, chegamos ao final do processo. Deu tudo certo! É
                hora de avançar!
              </li>
            </ul>
          </div>
        </article>
      </Collapsible>

      <Collapsible
        trigger={
          <div className={styles.questionTitle} onClick={() => handleOpen(1)}>
            <h3>A comunicação durante o processo de matrícula é feita como?</h3>
            <Image
              src="/images/arrow-down.svg"
              alt="Ícone de pergunta"
              width="23"
              height="14"
              className={`arrowSelectiveProcess1`}
            />
          </div>
        }
        className={styles.dropdown}
      >
        <article className={styles.question}>
          <div>
            <p>Nossa comunicação é feita por e-mail, WhatsApp e telefone.</p>
          </div>
        </article>
      </Collapsible>
    </div>
  );
}
